export default __webpack_public_path__ + "static/media/invision.f38e2128.png";